module.exports = __webpack_public_path__ + "img/services-it-security.bba4d039.png";